import { useSelector } from 'react-redux'

import { useGetCampionatiQuery, useGetCorsiQuery } from '../hooks/api-slice'
import { fromStringsToDateTime } from '../hooks/utils-functions'
import { colours } from '../settings/settings'

const GeneralInfo = () => {
  const isMobile = useSelector(state => state.home.isMobile)

  const { data: campionati } = useGetCampionatiQuery()
  const { data: corsi } = useGetCorsiQuery()

  const addInfo = (infos, text) => {
    infos.push(isMobile ? <br key={text} /> : ' — ')
    infos.push(text)
  }

  const StyledDiv = ({ colour, children }) => (
    <div
      style={{
        margin: 5,
        padding: 5,
        background: `linear-gradient(to right, ${colours.white} 0%, ${colour} 20%, ${colour} 80%, ${colours.white} 100%)`,
      }}
    >
      {children}
    </div>
  )

  const dCampionati = campionati
    ?.filter(c => !c?.campionatoChiuso)
    ?.map((c, index) => {
      let cInfos = []

      const cNome = c?.nome
      const iAperte = !!c?.iscrizioniAperte
      const cPubbl = !!c?.calendariPubblicati
      const cSpost = c?.termineSpostamentiGratuiti
      const cGironi = c?.termineGironi

      if (iAperte) {
        addInfo(cInfos, 'Iscrizioni aperte!')
      }

      const cSpostFuturo = fromStringsToDateTime(cSpost, '23:59') > new Date()
      if (cPubbl && cSpost && cSpostFuturo) {
        addInfo(cInfos, `Spostamenti gratuiti fino al ${cSpost}`)
      }

      const cGironiFuturo = fromStringsToDateTime(cGironi, '23:59') > new Date()
      if (cPubbl && cGironi && cGironiFuturo) {
        addInfo(cInfos, `Il termine per la fase a gironi è il ${cGironi}`)
      }

      if (!cInfos?.length) return null

      return (
        <StyledDiv key={index} colour={colours.highlightGreen}>
          <b>{cNome}</b>
          {cInfos}
        </StyledDiv>
      )
    })

  const dCorsi = corsi
    ?.filter(c => c?.iscrizioniAperte)
    ?.map((c, index) => {
      const cDate = c?.date
      const tDate =
        (cDate?.length === 0 && '') ||
        (cDate?.length === 1 && ` del ${cDate[0]}`) ||
        ` dal ${cDate[0]} al ${cDate[cDate.length - 1]}`

      return (
        <StyledDiv key={index} colour={colours.highlight}>
          Aperte le iscrizioni al <b>{c?.nome}</b>
          {tDate}
        </StyledDiv>
      )
    })

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      {dCampionati}
      {dCorsi}
    </div>
  )
}

export default GeneralInfo
